import styled from 'styled-components';
import { AngleIcon } from 'ui-components/src/components/atoms/icons';

export const Wrapper = styled.div<{ open: boolean }>`
  transition: height 0.3s;
  padding-left: 1rem;
  margin-bottom: ${({ open }) => (open ? '1rem' : 0)};
`;

export const ToggleIcon = styled(AngleIcon)`
  fill: ${({ theme }) => theme.colors.primary.blueDark};
  transition: fill 0.2s;
`;

export const Title = styled.h4`
  font-size: 16px;
  flex: 1;
  margin: 0;
`;

export const Header = styled.div<{ open: boolean }>`
  padding: 16px 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid
    ${({ theme, open }) => (open ? theme.colors.greyWarm['40'] : 'transparent')};

  &:hover ${ToggleIcon} {
    fill: ${({ theme }) => theme.colors.primary.cyan};
  }
`;

export const Container = styled.div<{ open: boolean }>`
  margin-top: 1rem;

  &:not(:first-child) > ${Header} {
    border-top: 1px solid ${({ theme }) => theme.colors.greyWarm['40']};
  }
`;

export const ToggleAction = styled.div<{ open: boolean }>`
  transition: transform 0.3s ease;
  transform: rotate(${({ open }) => (open ? '0deg' : '180deg')}) scale(0.8);
`;
